import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  inject,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { TIME_INTERVAL_TRANSFORMER_SERVICE, TimeIntervalTransformerService } from '@luggagehero/shared/interfaces';

import { BaseComponent } from '../../../core';
import { ExceptionalOpeningHours } from '../../../services/shops/exceptional-opening-hours';
import { OpeningHours } from '../../../services/shops/opening-hours';
import { DateUtil } from '../../../utils/date.util';

const ONE_DAY_MILLISECONDS = 1000 * 60 * 60 * 24;

@Component({ template: '' })
export abstract class ManageExceptionalOpeningHoursBaseComponent
  extends BaseComponent
  implements OnInit, AfterViewInit
{
  private timeIntervalService = inject<TimeIntervalTransformerService>(TIME_INTERVAL_TRANSFORMER_SERVICE);
  @Input() openingHours: OpeningHours;
  @Output() openingHoursChange: EventEmitter<OpeningHours>;
  @Output() pristineChange: EventEmitter<boolean>;

  exceptionDate: Date;
  minExceptionDate: Date;

  private _pristine = true;
  private isInitialized = false;

  constructor(private cd: ChangeDetectorRef) {
    super();
    this.openingHoursChange = new EventEmitter<OpeningHours>();
    this.pristineChange = new EventEmitter<boolean>();
  }

  get valid(): boolean {
    return OpeningHours.isValid(this.openingHours);
  }

  get pristine(): boolean {
    return this._pristine;
  }
  set pristine(value: boolean) {
    this._pristine = value;
    this.cd.markForCheck();

    this.pristineChange.emit(value);
  }

  ngOnInit() {
    const today = DateUtil.setTime(new Date(), 12);
    this.exceptionDate = today;

    const yesterday = new Date(today.getTime() - ONE_DAY_MILLISECONDS);
    this.minExceptionDate = yesterday;

    this.cd.markForCheck();
  }

  ngAfterViewInit() {
    this.isInitialized = true;
  }

  addException() {
    const exception = new ExceptionalOpeningHours();
    exception.date = DateUtil.setTime(this.exceptionDate, 12);
    exception.openingHours = [];

    this.openingHours.exceptions.push(exception);
    this.openingHours.exceptions.sort((a, b) => a.date.getTime() - b.date.getTime());
  }

  removeException(value: ExceptionalOpeningHours) {
    const index = this.openingHours.exceptions.indexOf(value);
    this.openingHours.exceptions.splice(index, 1);
  }

  onChange(_e) {
    this.openingHoursChange.emit(this.openingHours);

    if (this.isInitialized) {
      this.pristine = false;
    }
  }
}
